import React, { useCallback } from 'react';
import { Container, Col, Row, Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import './MexicanStateButtonPage.css';

// Mexican states data
const MEXICO_STATES_DATA = [
  { name: "Aguascalientes", flag: "/aguascalientesFlag.png", path: "/mexico/aguascalientes" },
  { name: "Baja California", flag: "/bajaCaliforniaFlag.png", path: "/mexico/bajacalifornia" },
  { name: "Baja California Sur", flag: "/bajaCaliforniaSurFlag.png", path: "/mexico/bajacaliforniasur" },
  { name: "Campeche", flag: "/campecheFlag.png", path: "/mexico/campeche" },
  { name: "Chiapas", flag: "/chiapasFlag.png", path: "/mexico/chiapas" },
  { name: "Chihuahua", flag: "/chihuahuaFlag.png", path: "/mexico/chihuahua" },
  { name: "Coahuila", flag: "/coahuilaFlag.png", path: "/mexico/coahuila" },
  { name: "Colima", flag: "/colimaFlag.png", path: "/mexico/colima" },
  { name: "Durango", flag: "/durangoFlag.png", path: "/mexico/durango" },
  { name: "Guanajuato", flag: "/guanajuatoFlag.png", path: "/mexico/guanajuato" },
  { name: "Guerrero", flag: "/guerreroFlag.png", path: "/mexico/guerrero" },
  { name: "Hidalgo", flag: "/hidalgoFlag.png", path: "/mexico/hidalgo" },
  { name: "Jalisco", flag: "/jaliscoFlag.png", path: "/mexico/jalisco" },
  { name: "Ciudad de México", flag: "/mexicoCityFlag.png", path: "/mexico/mexicocity" },
  { name: "Estado de México", flag: "/mexicoStateFlag.png", path: "/mexico/mexicostate" },
  { name: "Michoacán", flag: "/michoacanFlag.png", path: "/mexico/michoacan" },
  { name: "Morelos", flag: "/morelosFlag.png", path: "/mexico/morelos" },
  { name: "Nayarit", flag: "/nayaritFlag.png", path: "/mexico/nayarit" },
  { name: "Nuevo León", flag: "/nuevoLeonFlag.png", path: "/mexico/nuevoleon" },
  { name: "Oaxaca", flag: "/oaxacaFlag.png", path: "/mexico/oaxaca" },
  { name: "Puebla", flag: "/pueblaFlag.png", path: "/mexico/puebla" },
  { name: "Querétaro", flag: "/queretaroFlag.png", path: "/mexico/queretaro" },
  { name: "Quintana Roo", flag: "/quintanaRooFlag.png", path: "/mexico/quintanaroo" },
  { name: "San Luis Potosí", flag: "/sanLuisPotosiFlag.png", path: "/mexico/sanluispotosi" },
  { name: "Sinaloa", flag: "/sinaloaFlag.png", path: "/mexico/sinaloa" },
  { name: "Sonora", flag: "/sonoraFlag.png", path: "/mexico/sonora" },
  { name: "Tabasco", flag: "/tabascoFlag.png", path: "/mexico/tabasco" },
  { name: "Tamaulipas", flag: "/tamaulipasFlag.png", path: "/mexico/tamaulipas" },
  { name: "Tlaxcala", flag: "/tlaxcalaFlag.png", path: "/mexico/tlaxcala" },
  { name: "Veracruz", flag: "/veracruzFlag.png", path: "/mexico/veracruz" },
  { name: "Yucatán", flag: "/yucatanFlag.png", path: "/mexico/yucatan" },
  { name: "Zacatecas", flag: "/zacatecasFlag.png", path: "/mexico/zacatecas" }
];

const MexicanStateButtonPage = ({ onStateSelect }) => {
  const handleHapticsClick = useCallback(async (callback) => {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      // console.log('Haptics not available');
    }
    if (onStateSelect) {
      onStateSelect();
    }
    callback();
    window.scrollTo(0, 0);
  }, [onStateSelect]);

  const StateButton = useCallback(({ state }) => (
    <Link 
      id='pageLinkState' 
      onClick={() => handleHapticsClick(() => {})} 
      to={state.path}
    >
      <Button size='sm' id='statesModalButtons'>
        <Image id='stateFlagMobile' src={state.flag} alt={`${state.name} Flag`} />
        {state.name}
      </Button>
    </Link>
  ), [handleHapticsClick]);

  // Group states into rows of 3
  const stateRows = [];
  for (let i = 0; i < MEXICO_STATES_DATA.length; i += 3) {
    stateRows.push(MEXICO_STATES_DATA.slice(i, i + 3));
  }

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div id='homebg' className="mexican-state-button-page-root" style={containerStyle}>
      <Container>
        {stateRows.map((row, rowIndex) => (
          <Row key={rowIndex}>
            {row.map(state => (
              <StateButton key={state.name} state={state} />
            ))}
          </Row>
        ))}
      </Container>
    </div>
  );
};

export default MexicanStateButtonPage;